module.exports = __webpack_public_path__ + "img/aParty_032523_H.4d1ce273.jpg";